import React from 'react'
import PatientIdMagicLink from '../../components/SignIn/PatientIdMagicLink'

const PatientIdMagicLinkContainer = () => {
    return (
        <div>
            <PatientIdMagicLink />
        </div>
    )
}

export default PatientIdMagicLinkContainer
